import React from 'react';
import { motion } from 'framer-motion';
export function Tomos() {
  const tomos = [{
    num: 1,
    title: 'Nivel Inicial (Sin experiencia)',
    desc: 'El primer contacto con el yoga. Posturas base, respiración y confianza.'
  }, {
    num: 2,
    title: 'Nivel Inicial (Consolidación)',
    desc: 'Alineación, correcciones verbales y técnica de las posturas base.'
  }, {
    num: 3,
    title: 'Intermedio 1 (Vinyasa Suave)',
    desc: 'Conexión movimiento-respiración en un flujo continuo y consciente.'
  }, {
    num: 4,
    title: 'Intermedio 2 (Fuerza y Apertura)',
    desc: 'Desarrollo de fuerza funcional y apertura profunda de cadenas.'
  }, {
    num: 5,
    title: 'Avanzado',
    desc: 'Inversiones, equilibrios y posturas de alta demanda física y mental.'
  }, {
    num: 6,
    title: 'Adultos Mayores',
    desc: 'Yoga adaptado para cuerpos maduros. Movilidad, equilibrio y bienestar.'
  }, {
    num: 7,
    title: 'Lesiones y Rehabilitación',
    desc: 'Secuencias terapéuticas para hernias, rodillas y hombros.'
  }, {
    num: 8,
    title: 'Yoga Terapéutico',
    desc: 'Abordaje integral del cuerpo para condiciones crónicas.'
  }, {
    num: 9,
    title: 'Ansiedad y Restaurativo',
    desc: 'Técnicas de regulación del sistema nervioso y descanso profundo.'
  }, {
    num: 10,
    title: 'Prenatal y Postparto',
    desc: 'Secuencias seguras y amorosas para acompañar cada etapa.'
  }, {
    num: 11,
    title: 'Restaurativo Total',
    desc: 'Yoga Nidra, bolsters y mantas. La clase que todos necesitan.'
  }, {
    num: 12,
    title: 'Meditación y Pranayama',
    desc: 'Técnicas de respiración y meditación listas para dictar en cualquier clase.'
  }];
  const features = ['✏️ Ejercicios detallados en cada tomo', '⚡ Sistema "Abre y Dicta"', '📋 Fichas listas para imprimir', '✅ Contenido 100% adaptado a tus clases'];
  return <section className="py-20 px-4 bg-white" data-id="element-249">
      <div className="max-w-6xl mx-auto" data-id="element-250">
        <div className="text-center mb-16" data-id="element-251">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-oscuro mb-4" data-id="element-252">
            Los 12 Tomos Completos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600 font-medium" data-id="element-253">
            Secuencias detalladas · Por nivel y objetivo · Listo para usar desde
            mañana
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-254">
          {tomos.map((tomo, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-hueso p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-255">
              <div className="text-terracota font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-256">
                Tomo {tomo.num}
              </div>
              <h3 className="text-xl font-bold text-oscuro mb-3 leading-tight" data-id="element-257">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-258">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-259">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4 + idx * 0.1
        }} className="bg-salvia-light/50 p-4 rounded-xl text-center font-medium text-oscuro" data-id="element-260">
              {feature}
            </motion.div>)}
        </div>
      </div>
    </section>;
}